import { ReactNode } from "react"
import clsx from "clsx"

const formatNumber = (number: number | undefined | null) =>
  number ? new Intl.NumberFormat("en-US").format(number) : undefined

const Card = ({
  title,
  value,
  children,
  className,
}: {
  title: string
  value?: number | null
  children?: ReactNode
  className?: string
}) => {
  const formattedValue = formatNumber(value)

  return (
    <div
      className={clsx(
        "flex flex-col rounded-xl border border-gray-200 bg-white p-6 shadow-xs",
        className
      )}
    >
      <div className="flex-1">
        <h2 className="text-base leading-6 font-semibold text-gray-900">
          {title}
        </h2>
        {value !== null && (
          <p className="mt-4 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            {formattedValue ?? 0}
          </p>
        )}
      </div>
      {children ? (
        <div className="mt-6 h-64 w-full overflow-y-auto sm:h-96">
          {children}
        </div>
      ) : null}
    </div>
  )
}

export default Card
